/* Bisous & Co — accent produit (07/09/2026).
   Le CTA et la pastille du fold prennent la couleur du coloris selectionne, comme
   chez Comfrt. Le theme ne re-rend pas la section au changement de variante : on
   lit la couleur sur la pastille cochee (--swatch-background) et on pose des
   variables CSS sur la section. Sans pastille couleur : variables retirees, noir. */
(function () {
  function rgb(str) {
    var m = /rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/.exec(str || '');
    if (m) return [+m[1], +m[2], +m[3]];
    m = /^#?([0-9a-f]{6})$/i.exec((str || '').trim());
    if (m) return [parseInt(m[1].slice(0, 2), 16), parseInt(m[1].slice(2, 4), 16), parseInt(m[1].slice(4, 6), 16)];
    return null;
  }
  function apply(section) {
    if (!section) return;
    var c = null;
    var mapEl = section.querySelector('script[data-bs-colors]');
    var map = null;
    section.querySelectorAll('variant-picker input[type="radio"]:checked').forEach(function (input) {
      if (c) return;
      var label = input.closest('label') || input.parentElement;
      var s = label && label.querySelector('[style*="--swatch-background"]');
      if (!s) return;
      c = rgb(getComputedStyle(s).getPropertyValue('--swatch-background'));
      if (!c && mapEl) {
        /* Pastille image (entree Couleur avec photo) : --swatch-background vaut url(...),
           la couleur vient de la carte valeur -> hex emise par le Liquid de la section. */
        if (!map) { try { map = JSON.parse(mapEl.textContent) || {}; } catch (err) { map = {}; } }
        c = rgb(map[input.value]);
      }
    });
    var st = section.style;
    function black() {
      /* Pose le noir explicitement : le <style> emis par le Liquid au chargement porte
         encore la couleur initiale, effacer les variables la ferait reapparaitre. */
      st.setProperty('--bs-accent', '#111111');
      st.setProperty('--bs-accent-ink', '#ffffff');
      st.setProperty('--bs-accent-hover', '#000000');
    }
    if (!c) { black(); return; }
    var bright = (c[0] * 299 + c[1] * 587 + c[2] * 114) / 1000;
    if (bright >= 242) { black(); return; } /* blanc ou presque : CTA noir (demande Robin) ; seuil 235 -> 242 le 25/10 pour le Cream du NY Slipper (#F4F0E3 = 239.7) */
    var light = bright > 170;
    st.setProperty('--bs-accent', 'rgb(' + c.join(',') + ')');
    st.setProperty('--bs-accent-ink', light ? '#111111' : '#ffffff');
    st.setProperty('--bs-accent-hover', 'rgb(' + c.map(function (x) { return Math.round(x * 0.92); }).join(',') + ')');
  }
  function sectionOf(el) { return el && el.closest ? el.closest('.shopify-section') : null; }
  /* Au clic direct sur une pastille (phase de capture, avant le thème) : instantane,
     sans attendre variant:selected ni le fetch du theme. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.closest('variant-picker')) return;
    apply(sectionOf(input));
  }, true);
  ['variant:selected', 'variant:update'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var section = sectionOf(e.target);
      /* setTimeout plutot que requestAnimationFrame : rAF est suspendu dans un onglet
         masque, et l'evenement variant:selected part avant que l'input soit coche. */
      setTimeout(function () { apply(section); }, 0);
    });
  });
  /* Pont bundle -> fold : une pastille du produit principal (slot 0) dans le bloc
     Complete the Look coche la meme valeur dans le selecteur du fold. Prix, image,
     barre sticky et accent suivent alors par le chemin normal du theme. */
  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest ? e.target.closest('[data-cl-val][data-slot="0"]') : null;
    if (!pill) return;
    var section = sectionOf(pill);
    if (!section) return;
    var idx = pill.getAttribute('data-idx');
    var val = pill.getAttribute('data-v');
    var radios = section.querySelectorAll('variant-picker input[type="radio"][data-fieldset-index="' + idx + '"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === val) {
        if (!radios[i].checked) radios[i].click();
        break;
      }
    }
  }, true);

  function init() {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.querySelector('variant-picker')) apply(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
